import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IResult } from "../../../../../common/interfaces";
import { environment as env } from "../../../../../../environments/environment.prod";
import { AbstractService } from "app/services/abstract.service";
import { IUpdateSubRoute } from "../interfaces/update-sub-route.interface";
import SubRouteCollaboratorAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-collaborator/sub-route-collaborator.entity";
import { ICreateSubRouteCollaborator } from "./interfaces/create-sub-route-collaborator.interface";

const apiUrl = env.API_ROUTING_URL;
const moduleName = "sub-route-collaborators";

@Injectable({
  providedIn: "root",
})
export class SubRouteCollaboratorService extends AbstractService<SubRouteCollaboratorAttributes,ICreateSubRouteCollaborator,IUpdateSubRoute> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findBySubRouteId(
    subRouteId: string
  ): Observable<IResult<SubRouteCollaboratorAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${subRouteId}`;
    return this.http.get<IResult<SubRouteCollaboratorAttributes>>(API_URL);
  }
}
